import { FETCH_DIRECT_SALE_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const directSaleListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DIRECT_SALE_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default directSaleListReducer;
